import React from 'react';

import Typography from '@material-ui/core/Typography';

import MemberReferralsGrid from './MemberReferralsGrid';
import MemberMiniMenu from '../menus/MemberMiniMenu';

const MemberReferralsContent = () => {
    return (
        <div>
            <Typography variant="h6">Referrals</Typography>
            <MemberReferralsGrid />
        </div>
    );
}

const MemberReferralsPage = () => {
    return (
        <MemberMiniMenu>
            <MemberReferralsContent />
        </MemberMiniMenu>
    )
};

export default MemberReferralsPage;